import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import useAuth from "./useAuth";
import { userActions } from "../redux/actions";
import { tenantmgmtService } from "../services";
import { normalizeTenantList, pickDefaultTenant } from "../utils/normalizeTenant";

export default function useEnsureDefaultTenant() {
  const dispatch = useDispatch();
  const { isSystemUser, loggedIn, activeTenantId } = useAuth();
  const requestedRef = useRef(false);

  useEffect(() => {
    if (!loggedIn || !isSystemUser || activeTenantId || requestedRef.current) {
      return;
    }

    requestedRef.current = true;
    tenantmgmtService
      .getAllTenants()
      .then((payload) => {
        const tenant = pickDefaultTenant(normalizeTenantList(payload));
        if (!tenant?.slug && !tenant?.name) {
          requestedRef.current = false;
          return;
        }
        dispatch(
          userActions.setActiveTenant({
            id: tenant.name || tenant.slug,
            name: tenant.name || tenant.slug,
          })
        );
      })
      .catch(() => {
        requestedRef.current = false;
      });
  }, [activeTenantId, dispatch, isSystemUser, loggedIn]);
}
